<template>
	<div class="chat" id="mensagemAjuda">
		<div class="conteudo scroll" ref="item" :style="{ height: height - 60 + 'px' }">
			<div class="hacker-news-list" ref="item1">
				<!-- <div v-if="erro" class="text-center text-danger">
					<h4>
						<strong><i class="fa fa-fw fa-times"></i>{{ _traducao('global', 'erroConectarServidor')
}}</strong>
					</h4>
				</div> -->

				<!-- <div class="text-center">
					<flCarregando v-if="!conectado && !erro" />
				</div> -->
				<!-- <infinite-loading v-if="conectado" direction="top" ref="infiniteLoading" spinner="waveDots"
					@infinite="infiniteHandler">
					<div slot="no-more">
						<div style="padding: 8px">{{ _traducao('global', 'semMaisConversa').toUpperCase() }}</div>
					</div>
					<div slot="no-results">
						<div style="padding: 8px">{{ _traducao('global', 'nenhumaConversaEncontrada').toUpperCase() }}
						</div>
					</div>
				</infinite-loading> -->
				<div class="hacker-news-item" :class="item.class" v-for="(item, key) in list" :key="key">
					<!-- <span class="num">{{list.length - key}}</span> -->
					<div class="macro" :class="{ 'msj': item.id != _idUsuario, 'msj-vc': item.id == _idUsuario }"
						v-if="item.tipo == 'S'">
						<div class="container">
							<div class="row">
								<div class="col-xs-2 text-center col-xs-icon">
									<div class="row">
										<div class="col-xs-12 pd-fl-0">
											<i class="icon icon-cadastro_usuarios fa-fw icon-msg"></i>
										</div>
									</div>
								</div>
								<div class="col-xs-10" style="padding-left: 0px">
									<div class="row">
										<div class="col-xs-12">
											<small v-if="item.id == _idUsuario">
												<strong>{{ _traducao('global', 'voce') }}</strong>
											</small>
											<small v-else>
												<strong>{{ item.nome.toUpperCase() }}</strong>
											</small>
										</div>
									</div>
									<div class="row">
										<div v-if="item.mensagem.substring(0, 4) !== 'blob' && item.mensagem.length < 2000" class="col-xs-12">
											{{ item.mensagem }}
										</div>
										<div v-else-if="item.mensagem.substring(0,4) === 'blob'" class="col-xs-12">
											<audio class="audio" controls>
												<source class="source" :src="item.mensagem" type="audio/ogg" />
											</audio>
										</div>
										<div v-else>
											<img :src="item.mensagem" class="col-xs-12" />
										</div>
									</div>

									<div class="row" style="color: #777">
										<div class="col-xs-6">
											<small :title="item.data">{{ item.dt }}</small>
										</div>
										<div class="col-xs-6 text-right">
											<small>
												<i class="fa pull-right fa-check" v-if="item.dataUTCEntregue != null"
													style="margin-left: -6px; margin-top: 2px" aria-hidden="true"></i>
												<i class="fa pull-right fa-check" style="margin-top: 2px"
													aria-hidden="true"></i>{{ item.data.split(' ')[1] }}
											</small>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-else :class="{ 'msj-rta': item.id != _idUsuario, 'msj-rta-vc': item.id == _idUsuario }"
						class="macro">
						<div class="container">
							<div class="row">
								<div class="col-xs-2 text-center pr-0">
									<div class="row">
										<div class="col-xs-12 pr-0">
											<i class="icon fa icon-manutencao_celula_2 fa-fw icon-msg-2"></i>
										</div>
									</div>
								</div>
								<div class="col-xs-10">
									<div class="row">
										<div class="col-xs-12">
											<small v-if="item.id == _idUsuario">
												<strong>{{ _traducao('global', 'voce') }}</strong>
											</small>
											<small v-else>
												<strong>{{ item.nome.toUpperCase() }}</strong>
											</small>
										</div>
									</div>
									<div class="row">
										<div v-if="item.mensagem.substring(0, 4) !== 'blob' && item.mensagem.length < 2000" class="col-xs-12">
											{{ item.mensagem }}
										</div>
										<div v-else-if="item.mensagem.substring(0,4) === 'blob'" class="col-xs-12">
											<audio class="audio" controls>
												<source class="source" :src="item.mensagem" type="audio/ogg" />
											</audio>
										</div>
										<div v-else>
											<img :src="item.mensagem" class="col-xs-12" />
										</div>
									</div>

									<div class="row" style="color: #777">
										<div class="col-xs-6">
											<small :title="item.data">{{ item.dt }}</small>
										</div>
										<div class="col-xs-6 text-right">
											<small>
												<i class="fa pull-right fa-check" v-if="item.dataUTCEntregue != null"
													style="margin-left: -6px; margin-top: 2px" aria-hidden="true"></i>
												<i class="fa pull-right fa-check" style="margin-top: 2px"
													aria-hidden="true"></i>
												{{ item.data.split(' ')[1] }}
											</small>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-btn">
			<div class="col-xs-12">
				<a href="#" class="click-enviar" v-if="!enviando" @click.prevent="clickEnviarMensgem()">
					<i class="fa fa-paper-plane-o fa-fw" aria-hidden="true"></i>{{ _traducao('global', 'enviar') }}
				</a>

				<p v-if="enviando" class="click-enviar">
					<i class="fa fa-fw fa-spin fa-refresh"></i>{{ _traducao('global', 'enviando') }}...
				</p>
				<textarea type="text" @keydown.enter.prevent="clickEnviarMensgem()" @keyup="validaDescricao"
					v-model="mensagem" :rows="mensagem.length > 40 ? 2 : 1" class="form-control text-area">
																			</textarea>
			</div>
		</div>
	</div>
</template>

<style scoped>
.audio {
	--player-button-width: 3em;
	--sound-button-width: 2em;
	--space: .5em;
	width: 20rem;
	height: 4rem;
}

.audio::-webkit-media-controls-panel {
  background-color: #56AEFF;
}

.audio::-webkit-media-controls-play-button {
  background-color: #B1D4E0;
  border-radius: 50%;
}

.audio::-webkit-media-controls-play-button:hover {
  background-color: rgba(177,212,224, .7);
}

</style>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import $ from 'jquery'
export default {
	components: {
		InfiniteLoading
	},

	props: ['height', 'dadosAlertasAjuda'],

	data() {
		return {
			list: [],
			primeiro: true,
			mensagem: '',
			enviando: false,
			tempo: null,
			estado: null,
			stopBuscaMensagem: true,
		}
	},

	beforeDestroy() {
		this.stopBuscaMensagem = true
	},

	mounted() {
		this.stopBuscaMensagem = false
		this.recebeMensagem()
	},

	methods: {
		recebeMensagem() {

			this._httpService('/ajudaquevemdoceu/GetMensagem/' + this.dadosAlertasAjuda.ip, 'GET', null, (retorno) => {

				this.list = []

				for (let i = 0; i < retorno.length; i++) {
					this.list.push(retorno[i])
					if(retorno[i].mensagem.substring(0,3) === '/9j'){						
						retorno[i].mensagem = `data:image/jpeg;base64,${retorno[i].mensagem}`
					}
					else if (retorno[i].mensagem.length > 2000) {
						var snd = `data:audio/mp4;base64,${retorno[i].mensagem}`
						let binary = this.convertURIToBinary(snd);
						let blob = new Blob([binary], {
							type: 'audio/ogg'
						});
						let blobUrl = URL.createObjectURL(blob);
						retorno[i].mensagem = blobUrl
					}
				}

				this.list = this.processaLista(this.list)

				if (this.stopBuscaMensagem == false) {
					this.$nextTick(() => {
						this.$refs.item.scrollTop = 60000
					})
				}

				this.iniciaBuscaDados()
			})
		},

		convertURIToBinary(dataURI) {
			let BASE64_MARKER = ';base64,';
			let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
			let base64 = dataURI.substring(base64Index);
			let raw = window.atob(base64);
			let rawLength = raw.length;
			let arr = new Uint8Array(new ArrayBuffer(rawLength));

			for (let i = 0; i < rawLength; i++) {
				arr[i] = raw.charCodeAt(i);
			}
			return arr;
		},

		clickEnviarMensgem() {
			if (this.mensagem.trim() != '') {
				this.enviando = true
				var ip = this.dadosAlertasAjuda.ip

				var d = new Date,
					dformat = [d.getUTCFullYear(),
					d.getUTCMonth() + 1,
					d.getUTCDate()].join('-') + ' ' +
						[d.getUTCHours(),
						d.getUTCMinutes(),
						d.getUTCSeconds()].join(':');

				var dt = {
					mensagem: this.mensagem,
					celularr: "Followair",
					celulard: ip,
					data_utc: dformat,
					nome: "Followair"
				}

				clearTimeout(this.tempo)

				this._httpService('/ajudaquevemdoceu/ReceiveMessage/', 'POST', dt, (retorno) => {
					this.enviando = false
					this.recebeMensagem()
				})
			}
		},

		validaDescricao(event) {
			var sub = 130 - this.mensagem.length
			if (sub <= 0) {
				this.mensagem = this.mensagem.substring(0, this.mensagem.length - Math.abs(sub))
			}
			return true
		},

		processaLista(lista) {
			return lista.map((item) => {
				item.data = new moment.utc(item.data_utc).local().format($sessao.getDateFormat() + ' HH:mm:ss')
				item.dt = moment(item.data, $sessao.getDateFormat() + ' HH:mm:ss')
					.locale(this._getLangDp)
					.fromNow()
				item.class = ''
				item._index = new moment.utc(item.data_utc).local().unix()

				return item
			})
		},

		iniciaBuscaDados() {
			if (this.stopBuscaMensagem == false) {
				setTimeout(() => {
					this.recebeMensagem()
				}, 5000)
			}

		},
	}
}
</script>
